// extracted by mini-css-extract-plugin
export default {"volume-icon":"VolumeSlider_volume-icon__FzQsV"};